module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Squarecat","short_name":"Squarecat","start_url":"/","background_color":"#ffe066","theme_color":"#ffe066","display":"minimal-ui","icon":"src/assets/images/logo-square.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4980275fdd7f54abda74eb165c574167"},
    }]
